// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"509521d5","81":"99b32ec4","88":"1fc05ef9","144":"889bea36","163":"b83a3f58","311":"4cb5e0b3","363":"e74bf22a","433":"9eb88cbe","453":"63e577b6","525":"f8d4d139","748":"cb14aabc","819":"43f48cad","834":"b6a1e91a","912":"645f581a","966":"fda121bc","967":"007605d6"}[chunkId] + ".chunk.js";
};